import React, { cloneElement } from "react"
import createReactClass from "create-react-class"
import PropTypes from "prop-types"
import styles from "./tab-content.less"
import classnames from "classnames"

export default createReactClass({
  displayName: "TabContent",
  propTypes: {
    className: PropTypes.string,
    url: PropTypes.string,
    container: PropTypes.element,
  },
  render() {
    if (this.props.container) {
      return cloneElement(this.props.container, {
        className: classnames(styles.tabContent, this.props.container.props.className),
      })
    }

    return (
      <div className={classnames(styles.tabContent, this.props.className)}>
        {this.props.children}
      </div>
    )
  },
})
